<template>
  <!-- <a-drawer :maskClosable="false"width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider> -->

  <div>
    <div class="back">
      <div>
        <a-button type="link" @click="hanleBack"> 返回 </a-button> <span class="xiang">></span>
        <span style="margin-left: 10px" class="xiang">详情</span>
      </div>
      <div>
        <a-button type="primary" v-if="active == 1" @click="handleSave"> 保存 </a-button>
        <a-button
type="primary"
          v-if="form.acceptStatus == 1 && ((form.openAgentAudit && userType == 2) || userType == 1)"
          @click="$refs.Examine.init(form, 1)"
v-hasPermi="['abm-fix:order:edit03']"
style="margin-left: 20px">
          审核
        </a-button>
      </div>
    </div>
    <div class="card_container">
      <div :class="active == 1 ? 'card_item active' : 'card_item '" @click="handleChoose(1)">
        <div style="width: 100%" class="card_item_c">
          项目档案信息
          <div class="card_item_l" v-show="active == 1"></div>
        </div>
      </div>
      <!-- <div
        :class="active == 2 ? 'card_item active' : 'card_item '"
        @click="handleChoose(2)"
        v-if="form.status == 5 || form.status == 7"
      >
        <div style="width: 100%" class="card_item_c">
          验收报告
          <div class="card_item_l" v-show="active == 2"></div>
        </div>
      </div> -->
      <div
:class="active == 3 ? 'card_item active' : 'card_item '"
@click="handleChoose(3)"
        v-if="form.status == 5 || form.status == 7">
        <div style="width: 100%" class="card_item_c">
          管路图存档
          <div class="card_item_l" v-show="active == 3"></div>
        </div>
      </div>
      <div
:class="active == 5 ? 'card_item active' : 'card_item '"
@click="handleChoose(5)"
        v-if="form.status == 5 || form.status == 7">
        <div style="width: 100%" class="card_item_c">
          试压记录
          <div class="card_item_l" v-show="active == 5"></div>
        </div>
      </div>

      <div
:class="active == 6 ? 'card_item active' : 'card_item '"
@click="handleChoose(6)"
        v-if="(form.status == 5 || form.status == 7) && productModelResults.length">
        <div style="width: 100%" class="card_item_c">
          积分清单
          <div class="card_item_l" v-show="active == 6"></div>
        </div>
      </div>
      <div :class="active == 4 ? 'card_item active' : 'card_item '" @click="handleChoose(4)">
        <div style="width: 100%" class="card_item_c">
          订单流程
          <div class="card_item_l" v-show="active == 4"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div v-if="active == 1">
        <a-form-model
ref="form"
:label-col="{ span: 7 }"
:wrapper-col="{ span: 17 }"
:model="form"
:rules="rules"
          class="form_model"
labelAlign="left">
          <a-form-model-item label="服务单号" prop="orderNo">
            <a-input v-model="form.orderNo" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="业主姓名" prop="ownerName">
            <a-input v-model="form.ownerName" placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="业主电话" prop="ownerPhone">
            <a-input v-model="form.ownerPhone" placeholder="请输入" :maxLength="11" />
          </a-form-model-item>
          <a-form-model-item label="小区名称" prop="minAreaName">
            <a-input v-model="form.minAreaName" placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="预约时间" prop="reservationTime">
            <a-input v-model="form.reservationTime" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="订单类型" prop="orderType" v-if="!form.id">
            <a-radio-group v-model="form.orderType" button-style="solid">
              <a-radio-button :value="0"> 普通服务单 </a-radio-button>
              <a-radio-button :value="1"> 预约服务单 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="企业品牌" prop="tenantFirmId" v-if="form.tenantFirmId !== form.tenantAgentId">
            <!-- <a-select
              show-search
              :allowClear="true"
              v-model="form.tenantFirmId"
              placeholder="请选择"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleTenant"
            >
              <a-select-option v-for="d in brandList" :key="d.id">{{ d.name }}</a-select-option>
            </a-select> -->
            <a-input v-model="form.tenantFirmName" placeholder="请输入" disabled />

            <!-- <a-input v-model="form.tenantFirmName" placeholder="请输入" :maxLength="50" disabled /> -->
          </a-form-model-item>

          <a-form-model-item label="经销商" prop="tenantId">
            <a-input
v-model="form.tenantName"
placeholder="请输入"
disabled
              v-if="form.tenantAgentId == form.tenantId" />
            <a-input v-model="name" placeholder="请输入" disabled v-else-if="form.tenantAgentId == '0'" />
            <a-input v-model="form.tenantAgentName" placeholder="请输入" disabled v-else />
          </a-form-model-item>
          <a-form-model-item
label="分销商"
prop="tenantId"
            v-if="form.tenantAgentId !== form.tenantId && form.tenantFirmId !== form.tenantId">
            <a-input v-model="form.tenantName" placeholder="请输入" disabled />
          </a-form-model-item>
          <!-- <a-form-model-item label="分销商" prop="tenantId" v-else>
       <a-select
                  show-search   :allowClear="true"
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in agentList" :key="d.userId">{{ d.userName }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
          <a-form-model-item label="验收员名称" prop="pressureTestUserId" v-if="form.pressureTestName">
            <!-- {{ form.pressureTestName }} -->
            <a-input v-model="form.pressureTestName" placeholder="请输入" disabled />
            <!-- <a-select
              show-search
              :allowClear="true"
              v-model="form.pressureTestUserId"
              placeholder="请选择"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleChange"
            >
              <a-select-option v-for="d in inspector" :key="d.userId"
                >{{ d.userName }}({{ d.userPhone }})</a-select-option
              >
            </a-select> -->
          </a-form-model-item>
          <a-form-model-item label="验收员电话" prop="pressureTestUserPhone" v-if="form.pressureTestUserPhone">
            <a-input v-model="form.pressureTestUserPhone" placeholder="请输入" disabled />
          </a-form-model-item>
          <a-form-model-item label="水工姓名" prop="waterName" v-if="form.waterName">
            <a-input v-model="form.waterName" placeholder="请输入" disabled />
          </a-form-model-item>
          <a-form-model-item label="水工电话" prop="waterPhone" v-if="form.waterPhone">
            <a-input v-model="form.waterPhone" placeholder="请输入" disabled />
          </a-form-model-item>
          <!-- <a-form-model-item label="省市区" prop="area">
            <v-distpicker
              :province="form.province"
              :city="form.city"
              :area="form.area"
              @province="onChangeProvince"
              @city="onChangeCity"
              @area="onChangeArea"
            >
            </v-distpicker>
          </a-form-model-item> -->
          <a-form-model-item label="设备MAC" prop="devCode" v-if="reportInfoResult.devCode">
            <a-input v-model="reportInfoResult.devCode" placeholder="请输入" disabled />
          </a-form-model-item>
          <a-form-model-item label="产品品类" prop="categoryProduct">
            <a-input v-model="reportInfoResult.categoryProduct" placeholder="请输入" disabled />
          </a-form-model-item>
          <a-form-model-item label="详细地址" prop="ownerAddress">
            <a-input v-model="form.ownerAddress" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-input
v-model="reportInfoResult.remark"
              :placeholder="reportInfoResult.remark ? reportInfoResult.remark : ''"
type="textarea"
disabled
              allow-clear />
          </a-form-model-item>
          <a-form-model-item label="驳回原因" prop="remark">
            <a-input
v-model="form.acceptRemark"
:placeholder="form.acceptRemark ? form.acceptRemark : ''"
              type="textarea"
disabled
allow-clear />
          </a-form-model-item>
        </a-form-model>
        <!-- <mapAdd ref="map" @getInfo="getInfo"></mapAdd> -->
      </div>
      <div v-if="(form.status == 5 || form.status == 7) && active == 1">
        <a-form-model
:label-col="{ span: 6 }"
:wrapper-col="{ span: 18 }"
ref="reportInfoResult"
          :model="reportInfoResult"
:rules="rules"
class="form_model">
          <!-- <a-form-model-item label="预约类型" prop="orderNo">
            <a-input v-model="reportInfoResult.orderNo" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <a-form-model-item label="连接点检查" prop="connectionCheck">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="服务类型" prop="serviceTypeName">
            <a-input v-model="reportInfoResult.serviceTypeName" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="预设压力" prop="presetPressure">
            <a-input v-model="reportInfoResult.presetPressure" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>

          <a-form-model-item label="业主在场" prop="orderNo">
            <a-select v-model="reportInfoResult.ownersPresent" disabled>
              <a-select-option :value="0"> 否 </a-select-option>
              <a-select-option :value="1"> 在 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="全套产品" prop="completeProducts">
            <a-select v-model="reportInfoResult.completeProducts" disabled>
              <a-select-option :value="0"> 否 </a-select-option>
              <a-select-option :value="1"> 是 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="预设时间" prop="presetTime">
            <a-input v-model="reportInfoResult.presetTime" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>

          <a-form-model-item label="房屋面积" prop="housingArea">
            <a-input v-model="reportInfoResult.housingArea" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="房屋类型" prop="houseType">
            <a-input v-model="reportInfoResult.houseType" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="起始压力" prop="initialPressure">
            <a-input v-model="reportInfoResult.initialPressure" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="购买渠道" prop="purchaseChannels">
            <a-input v-model="reportInfoResult.purchaseChannels" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="装修情况" prop="decorationSituation">
            <a-input v-model="reportInfoResult.decorationSituation" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="结束压力" prop="endPressure">
            <a-input v-model="reportInfoResult.endPressure" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="施工主体" prop="constructionSubject">
            <a-input v-model="reportInfoResult.constructionSubject" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="施工属性" prop="constructionAttributes">
            <a-input v-model="reportInfoResult.constructionAttributes" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="过程降压" prop="processPressureDrop">
            <a-input v-model="reportInfoResult.processPressureDrop" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>

          <a-form-model-item label="品牌" prop="valveBrand">
            <a-input v-model="reportInfoResult.valveBrand" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="装修公司" prop="decorationCompany">
            <a-input v-model="form.decorationCompany" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <!-- <a-form-model-item label="" prop=""> </a-form-model-item>
          <a-form-model-item label="预设压力" prop="presetPressure">
            <a-input v-model="reportInfoResult.presetPressure" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="起始压力" prop="initialPressure">
            <a-input v-model="reportInfoResult.initialPressure" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="出水口数" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="系统类型" prop="systemType">
            <a-input v-model="reportInfoResult.systemType" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <!-- <a-form-model-item label="阀门数量" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="产品名称" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <!-- <a-form-model-item label="管道长度" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <!-- <a-form-model-item label="试压用时" prop="exertTime">
            <a-input v-model="reportInfoResult.exertTime" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="参考试压" prop="presetTime">
            <a-input v-model="reportInfoResult.presetTime" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <!-- <a-form-model-item label="分水器数" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="厨房数量" prop="kitchenCount">
            <a-input v-model="reportInfoResult.kitchenCount" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <a-form-model-item label="开始时间" prop="startTime">
            <a-input v-model="reportInfoResult.startTime" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="质保承诺" prop="warrantyCommitment">
            <a-input v-model="reportInfoResult.warrantyCommitment" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="安装方式" prop="installationMethod">
            <!-- <span v-if="reportInfoResult.installationMethods.indexOf(0)">地面走管,</span>
            <span v-if="reportInfoResult.installationMethods.indexOf(1)">墙面走管,</span>
            <span v-if="reportInfoResult.installationMethods.indexOf(2)">屋顶走管</span> -->
            <a-input v-model="installationMethods" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="结束时间" prop="endTime">
            <a-input v-model="reportInfoResult.endTime" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item label="施工空间" prop="spatialDataOne">
            <!-- <span>{{ reportInfoResult.spatialDataOne }}室</span>
            <span>{{ reportInfoResult.spatialDataTwo }}厅</span>
            <span>{{ reportInfoResult.spatialDataFree }}厨</span>
            <span>{{ reportInfoResult.spatialDataFour }}卫</span> -->
            <a-input v-model="spatialDataFour" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>

          <!-- <a-form-model-item label="卫生间数" prop="toiletCount">
            <a-input v-model="reportInfoResult.toiletCount" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <!-- <a-form-model-item label="检查地址" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="前置过滤器数" prop="orderNo">
            <a-input v-model="reportInfoResult.connectionCheck" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->

          <!-- <a-form-model-item label="房屋户型" prop="houseLayout">
            <a-input v-model="reportInfoResult.houseLayout" disabled placeholder="请输入" :maxLength="50" />
          </a-form-model-item> -->
          <a-form-model-item label="业主评价" prop="ownerEvaluate">
            <a-select v-model="reportInfoResult.ownerEvaluate" disabled>
              <a-select-option :value="0"> 未评价 </a-select-option>
              <a-select-option :value="1"> 非常满意 </a-select-option>
              <a-select-option :value="2"> 满意 </a-select-option>
              <a-select-option :value="3"> 不满意 </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="判断结果" prop="pressureResult">
            <!-- <a-select v-model="reportInfoResult.pressureResult" disabled>
              <a-select-option :value="0"> 合格 </a-select-option>
              <a-select-option :value="1"> 不合格 </a-select-option>
            </a-select> -->
            <!-- <span v-if="reportInfoResult.processPressureDrop < 1.1 || reportInfoResult.processPressureDrop > -0.1"
              >合格</span
            >
            <span v-else>不合格</span> -->
            <a-input v-model="pressureResult" disabled placeholder="" :maxLength="50" />
          </a-form-model-item>
          <!-- <a-form-model-item label="分销商" prop="tenantId" v-else>
       <a-select
                  show-search   :allowClear="true"
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in agentList" :key="d.userId">{{ d.userName }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
        </a-form-model>
      </div>
      <div v-if="active == 6">
        <!-- <div v-for="(item, index) in productModelResults" :key="index">
              <template v-if="item.name && item.quantity">
                <a-col :span="2">产品名称</a-col>
                <a-col :span="2">{{ item.name }}</a-col>
                <a-col :span="2">产品数量</a-col>
                <a-col :span="2">{{ item.quantity }}</a-col>
                <a-col :span="2">产品单位</a-col>
                <a-col :span="2">{{ item.unit }}</a-col>
              </template>
<template v-if="item.inspectors.length">
              <div>产品积分</div>
              <div v-for="(items, indexs) in item.inspectors" :key="indexs">
                <a-col :span="2">水工积分</a-col>
                <a-col :span="2">{{ items.hydraulicIntegral }}</a-col>
                <a-col :span="2">经销商金豆</a-col>
                <a-col :span="2">{{ items.dealersIntegral }}</a-col>
                <a-col :span="2">验收员积分</a-col>
                <a-col :span="2">{{ items.inspectorPoints }}</a-col>
                <a-col :span="2">是否开启=向下分发积分</a-col>
                <a-col :span="2">{{ items.openDownwardDistributionIntegral }}</a-col>
                <a-col :span="2">类型</a-col>
                <a-col :span="2">{{ items.type == 0 ? '企业品牌' : items.type == 1 ? '代理' : '经销' }}</a-col>
              </div>
            </template>
</div> -->
        <div v-for="(item, index) in productModelResults" :key="index">
          <div style="margin-bottom: 10px" class="chanTitle">产品型号</div>
          <a-row v-if="item.name && item.quantity" style="margin-bottom: 10px">
            <a-col :span="2">产品名称</a-col>
            <a-col :span="2">
              <div class="chanBian">
                {{ item.name }}
              </div>
            </a-col>
            <a-col :span="2">产品规格</a-col>
            <a-col :span="2">
              <div class="chanBian">
                {{ item.caliber }}
              </div>
            </a-col>
            <a-col :span="2">产品数量</a-col>
            <a-col :span="2">
              <div class="chanBian">{{ item.quantity }}{{ item.unit }}</div>
            </a-col>
            <a-col :span="2">产品属性</a-col>
            <a-col :span="2">
              <div div class="chanBian">{{ item.attributeName }}</div>
            </a-col>
            <!-- <a-col :span="2">产品属性</a-col>
            <a-col :span="2"
              ><div div class="chanBian">{{ item.attributeName }}</div></a-col
            >
            <a-col :span="2">产品属性</a-col>
            <a-col :span="2"
              ><div div class="chanBian">{{ item.attributeName }}</div></a-col
            > -->
            <!-- <a-col :span="2"></a-col>
            <a-col :span="2"
              ><div div class="chanBian"></div></a-col
            >
            <a-col :span="2"></a-col>
            <a-col :span="2"
              ><div div class="chanBian"></div></a-col
            > -->
            <div></div>
          </a-row>

          <div>
            <a-row style="margin-bottom: 10px">
              <a-col :span="2">经销商金豆</a-col>
              <a-col :span="2">
                <div div class="chanBian">{{ item.golden01 }}</div>
              </a-col>
              <a-col :span="2">分销商金豆</a-col>
              <a-col :span="2">
                <div div class="chanBian">{{ item.golden02 }}</div>
              </a-col>
              <a-col :span="2">验收员积分</a-col>
              <a-col :span="2">
                <div div class="chanBian">{{ item.pointsExaminer }}</div>
              </a-col>
              <a-col :span="2">水工积分</a-col>
              <a-col :span="2">
                <div div class="chanBian">{{ item.pointsWater }}</div>
              </a-col>
            </a-row>
          </div>
          <!-- <div v-for="(items, indexs) in item.inspectors" :key="indexs">
            <div style="margin-bottom: 10px" class="chanTitle">积分明细</div>
            <a-row style="margin-bottom: 10px">
              <a-col :span="2">赋分主体</a-col>
              <a-col :span="2"
                ><div class="chanBian">
                  {{ items.type == 0 ? '企业品牌' : items.type == 1 ? '经销商' : '分销商' }}
                </div></a-col
              >
              <a-col :span="2">是否赋能</a-col>
              <a-col :span="2">
                <div>
                  <div class="chanBian">
                    {{ items.openDownwardDistributionIntegral ? '是' : '否' }}
                  </div>
                </div></a-col
              >
              <a-col :span="2">{{ items.type == 0 ? '经销商' : items.type == 1 ? '分销商' : '经销商' }}金豆</a-col>
              <a-col :span="2"
                ><div class="chanBian">
                  {{ items.dealersIntegral }}
                </div></a-col
              >
              <a-col :span="2">验收员积分</a-col>
              <a-col :span="2"
                ><div class="chanBian">
                  {{ items.inspectorPoints }}
                </div></a-col
              >
              <a-col :span="2">水工积分</a-col>
              <a-col :span="2"
                ><div class="chanBian">
                  <div>{{ items.hydraulicIntegral }}</div>
                </div></a-col
              >
            </a-row>
          </div> -->
        </div>
        <div>
          <div style="margin-bottom: 10px" class="chanTitle">积分明细</div>
          <a-row style="margin-bottom: 10px">
            <a-col :span="2">经销商金豆</a-col>
            <a-col :span="2">
              <div class="chanBian">
                {{ form.golden01 }}
              </div>
            </a-col>
            <a-col :span="2">分销商金豆</a-col>
            <a-col :span="2">
              <div class="chanBian">
                {{ form.golden02 }}
              </div>
            </a-col>
            <a-col :span="2">验收员积分</a-col>
            <a-col :span="2">
              <div class="chanBian">
                {{ form.pointsExaminer }}
              </div>
            </a-col>
            <a-col :span="2">水工积分</a-col>
            <a-col :span="2">
              <div class="chanBian">
                <div>{{ form.pointsWater }}</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div v-if="active == 3">
        <a-card title="VR全景">
          <div v-if="form.vrUrl">
            <a-button type="primary" @click="handleLook(form.vrUrl)">水电管路图查询 </a-button>
          </div>
        </a-card>
        <a-card title="其他资料链接" v-if="form.otherVrUrl">
          <div v-if="form.otherVrUrl">
            <a-button type="primary" @click="handleLook(form.otherVrUrl)">其他资料链接 </a-button>
          </div>
        </a-card>
        <div v-for="(item, index) in optionsType" :key="index">
          <a-card :title="item.strVal" v-if="item.files && item.files.length">
            <div v-viewer>
              <template v-for="(items, indexs) in item.files">
                <img
style="margin-bottom: 5px"
v-if="items"
:src="$url + items"
alt=""
:key="indexs"
@error="
                  (e) => {
                    e.target.src = errorImage
                  }
                " />
              </template>
            </div>
          </a-card>
        </div>
      </div>
      <div v-if="active == 5">
        <lineChart :chartData="chartData"></lineChart>
      </div>
      <!-- 订单流程 -->
      <div v-if="active == 4">
        <a-timeline>
          <a-timeline-item :color="item.state == 0 ? 'green' : 'red'" v-for="(item, index) in recordList" :key="index">
            {{ item.descriptionVal }}{{ item.remark ? item.remark : '' }}
          </a-timeline-item>
        </a-timeline>
      </div>
    </div>
    <Examine ref="Examine" @ok="handleOk" @changeStatus="changeStatus"></Examine>
  </div>
  <!-- </a-drawer> -->
</template>
<script>
import { getObj, addObj, putObj, tenantUser, addObj1, acceptance, recordPage } from '@/api/pressure/dispatch'
import mapAdd from '@/components/AMap/index'
import moment from 'moment'
import Examine from './examine'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import lineChart from '@/views/Charts/lineChart.vue'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: { mapAdd, Examine, lineChart },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      reportInfoResult: {
        connectionCheck: '',
      },
      formTitle: '',
      inputValue: '',
      inputValues: '',
      show: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      recordList: [],
      form: {},
      rules: {
        ownerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        reservationPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        proBane: [{ required: true, message: '请输入项目经理', trigger: 'blur' }],
        proPhone: [
          { required: true, message: '请输入项目经理电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        vrUrl: [{ required: true, message: '请输入VR 地址', trigger: 'blur' }],
        reservationName: [{ required: true, message: '请输入预约姓名', trigger: 'blur' }],
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        // tenantAgentId: [{ required: true, message: '请选择代理商', trigger: 'blur' }],
        // tenantId: [{ required: true, message: '请选择分销商', trigger: 'blur' }],
        minAreaName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入业主姓名', trigger: 'blur' }],
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        ownerAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        reservationTime: [{ required: true, message: '请选择预约时间', trigger: 'blur' }],
        area: [{ required: true, message: '请在地图上选择位置信息', trigger: 'blur' }],
      },
      dtoContent: [],
      // 表单参数
      form: {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
      },
      isShow: false,
      open: false,
      inspector: [],
      distributionList: [],
      agentList: [],
      fileManyFileResults: [],
      defTimelist: [
        {
          label: '09: 00 - 11: 00',
          value: '09:00 - 11:00',
        },
        {
          label: '11: 00 - 13: 00',
          value: '11:00 - 13:00',
        },
        {
          label: '13: 00 - 15: 00',
          value: '13:00 - 15:00',
        },
        {
          label: '15: 00 - 17: 00',
          value: '15:00 - 17:00',
        },
        {
          label: '17: 00 - 19: 00',
          value: '17:00 - 19:00',
        },
        {
          label: '19: 00 - 21: 00',
          value: '19:00 - 21:00',
        },
      ],
      optionsType: [],
      active: 1,
      evaluateInfoResult: {},
      brandList: [],
      chartData: null,
      productModelResults: [],
      pressureResult: '合格',
      installationMethods: '',
      spatialDataFour: '',
      // labelCol: { span: 8 },
      // wrapperCol: { span: 20 },
      options: ['地面走管', '墙面走管', '屋顶走管'],
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    tenantId() {
      return this.$store.state.user.userTentant.tenantId
    },
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  filters: {
    orderStates(value) {
      let num
      if (value === 0) {
        num = '待确认'
      } else if (value === 1) {
        num = '待派单'
      } else if (value === 2) {
        num = '派单拒绝'
      } else if (value === 3) {
        num = '待接单'
      } else if (value === 4) {
        num = '已受理'
      } else if (value === 5) {
        num = '已提交审核'
      } else if (value === 7) {
        num = '已完成'
      } else if (value === 8) {
        num = '订单作废'
      }
      return num
    },
  },
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    // this.getUserList(0)
    console.log('对对对对对对')
    this.initDtoContentType1()
  },
  watch: {},
  methods: {
    // 点击审核
    changeStatus() {
      this.$emit('changeStatus')
    },
    // 经销商发生变化
    handleAgent(e) {
      this.getMy({ tenantIdUp: e, type: 2 }, 3)
    },
    // 审核
    handleShen() { },
    // / 验收员选择发生变化
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    initDtoContentType1() {
      const list = []
      const len = 7
      const today = moment()
      for (let i = 0; i < len; i++) {
        var o = {
          id: i + 1,
          children: this.defTimelist,
        }
        if (i === 0) {
          o.value = today.add(0, 'days').format('YYYY-MM-DD')
          o.label = '今天(' + o.value + ')'
          console.log(o, 'o.timelisto.timelist')
          const currentTime = today.format('HH:mm')
          console.log(currentTime, 'currentTime')

          const filteredSlots = o.children.filter((slot) => {
            // 获取时间段的开始时间
            const startTime = slot.value.split(' - ')[1]
            console.log(startTime, 'startTimestartTime')
            return startTime > currentTime
          })
          o.children = filteredSlots
        } else if (i === 1) {
          o.value = today.add(1, 'days').format('YYYY-MM-DD')
          o.label = '明天(' + o.value + ')'
        } else if (i === 2) {
          o.value = today.add(2, 'days').format('YYYY-MM-DD')
          o.label = '后天(' + o.value + ')'
        } else {
          o.label = today.add(i, 'days').format('YYYY-MM-DD')
          o.value = today.add(i, 'days').format('YYYY-MM-DD')
        }
        list.push(o)
      }
      console.log(list, 'listlistlist')

      this.dtoContent = list
    },
    onChangeTime(e) {
      console.log(e, '大名鼎鼎的')
      this.form.reservationTime = e[0] + '  ' + e[1]
      console.log(this.form.reservationTime, ' this.form.reservationTimes')
    },
    // 点击修改信息
    handleSave() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            const query = JSON.parse(JSON.stringify(this.form))
            if (query.isShow === 1) {
              query.reservationName = undefined
              query.reservationPhone = undefined
            }
            if (this.userType === 0) {
              if (!query.tenantFirmId) {
                query.tenantFirmId = this.tenantId
                query.tenantAgentId = this.tenantId
                query.tenantId = this.tenantId
              } else if (!query.tenantAgentId) {
                query.tenantAgentId = 0
                query.tenantId = query.tenantFirmId
              } else if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
              query.pressureTestUserId = 0
            } else if (this.userType === 1) {
              query.tenantFirmId = this.tenantId
              if (!query.tenantAgentId) {
                query.tenantAgentId = 0
                query.tenantId = query.tenantFirmId
              } else if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
            } else if (this.userType === 2) {
              query.tenantAgentId = this.tenantId
              if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
            }
            if (query.orderType === 0) {
              // 普通订单
              addObj(query)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            } else {
              // 预约订单
              addObj1(query)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            }
          }
        } else {
          return false
        }
      })
    },
    // 点击切换tabs
    callback(key) {
      console.log(key)
      key = Number(key)
      this.active = key
      if (key === 2) {
      }
    },
    hanleBack() {
      this.$emit('back')
    },
    // 点击审核通过
    handleOk() {
      this.init(this.form)
    },
    // 查询验收和水工
    getUserList(type) {
      console.log(type, '测试数据====企业品牌啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪')
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    handleChoose(e) {
      this.$nextTick(() => {
        this.active = e
        if (this.active === 4) {
          console.log(this.form.id, 'this.form.id')

          recordPage({ orderId: this.form.id }).then((res) => {
            console.log(res, '顶顶顶顶')
            this.recordList = res.data
          })
        }
      })
    },
    // 打开vr连接
    handleLook(e) {
      window.open(e)
    },
    // 下载验收报告
    handleDown(e) {
      acceptance(e.id).then((res) => {
        window.open(res.data, '_blank')
      })
      // window.open(e)
    },
    // 生成pdf
    handlePdf() {
      this.downloadPDF(document.querySelector('#pdf'), '派单报告')
    },
    // 企业品牌发生变化
    handleTenant(e) {
      console.log(e, '对对对对对对')
      if (this.userType !== 2) {
        this.getMy({ tenantIdUp: e, type: 2 }, 2)
      } else {
      }
    },
    downloadPDF(ele, pdfName) {
      const eleW = ele.offsetWidth // 获得该容器的宽
      const eleH = ele.offsetHeight // 获得该容器的高
      console.log(eleH, 'eleWeleW==')
      const eleOffsetTop = ele.offsetTop // 获得该容器到文档顶部的距离
      const eleOffsetLeft = ele.offsetLeft // 获得该容器到文档最左的距离
      console.log(eleOffsetLeft, 'eleOffsetLeft')
      var canvas = document.createElement('canvas')
      var abs = 0
      const win_in = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
      const win_out = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2 // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }
      console.log(win_in, 'win_inwin_in')
      canvas.width = eleW * 2 // 将画布宽&&高放大两倍
      canvas.height = eleH * 2
      var context = canvas.getContext('2d')
      context.scale(2, 2)
      context.translate(-eleOffsetLeft - abs, -eleOffsetTop)
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉
      // html2canvas(element).then( (canvas)=>{ //报错
      // html2canvas(element[0]).then( (canvas)=>{
      window.scroll(0, 1) // 这行代码也需要写！
      const node = document.getElementById('pdf')
      var imgWidth = 595.28
      const elehs = this.leg > 14 ? eleH + 80 : eleW + 80
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 获取滚动轴滚动的长度
      html2canvas(ele, {
        dpi: window.devicePixelRatio * 2,
        X: 0,
        useCORS: true, // 开启跨域配置
        scale: 2,
        width: elehs,
        // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
        useCORS: true, // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then((canvas) => {
        var contentWidth = canvas.width
        var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        var leftHeight = contentHeight
        // 页面偏移
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgHeight = (595.28 / contentWidth) * contentHeight
        var pageData = canvas.toDataURL('image/jpeg', 1)
        // console.log(pageData, 'pageDatapageDatapageData===')
        var pdf = new JsPDF('', 'pt', 'a4')

        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
        const pdfHight = (pdf.internal.pageSize.height - imgHeight) / 2
        const pdfHights = pdf.internal.pageSize.height - imgHeight - 10
        const indexs = this.leg > 14 ? pdfHights : 10
        var position = 10
        const pdfWidths = (pdf.internal.pageSize.width - eleW) / 2
        // console.log(pdf.internal.pageSize.width, 'pdfHightpdfHightpdfHight');
        if (leftHeight < pageHeight) {
          // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, 'JPEG', 10, indexs, imgWidth, imgHeight)
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 10, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            // 避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }
        var pdfData = pdf.output('datauristring') // 获取base64Pdf
        // console.log(pdfData, 'pdfDatapdfDatapdfData获取base64的方法===');
        setTimeout(() => {
          dataPdf({ base64Str: pdfData, userId: this.dataFrom.userId }).then((res) => {
            console.log(res.data.data, '滴滴滴滴滴滴')
            var u = navigator.userAgent
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
            if (isiOS) {
              webkit.messageHandlers.appExport.postMessage(res.data.data)
            } else {
              // webView.getSettings().setJavaScriptEnabled(true);
              window.android.postPdfAddress(res.data.data)
            }
          })
        }, 1000)
        setTimeout(() => {
          // 可动态生成
          pdf.save(pdfName)
        }, 2000)
      })
    },
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime = moment(e).format('YYYY-MM-DD HH:mm')
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getInfo(e) {
      this.form.ownerAddress = e.detailedAddress
      this.form.lat = e.lat
      this.form.log = e.lng
      this.form.province = e.addressComponent.province
      this.form.city = e.addressComponent.city ? e.addressComponent.city : e.addressComponent.province
      this.form.area = e.addressComponent.district
      this.$forceUpdate()
      // console.log(e, 'ddddmm打得动');
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
      }
    },
    // 点击提交型号口径
    handleModelAdd() {
      if (this.form.modelCaliberAddParams.length === 0) {
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      } else {
        const index = this.form.modelCaliberAddParams.length - 1
        if (!this.form.modelCaliberAddParams[index].name) return this.$message.error('请输入口径名称')
        if (!this.form.modelCaliberAddParams[index].sort) return this.$message.error('请输入口径排序')
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      }
    },
    handleModelDel(index) {
      this.form.modelCaliberAddParams.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加预约订单'
    },
    /** 修改按钮操作 */
    init(row, ids) {
      console.log(1111)
      //   this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        // console.log(response.data.reservationTime,'response.data.reservationTime')
        // response.data.reservationTimes = '2025-01-13 / 13:00 - 15:00'
        if (response.data.installationMethod) {
          const arr = response.data.installationMethod.split(',')
          response.data.installationMethods = ''
          arr.forEach((v, index) => {
            // this.
            if (index === arr.length - 1) {
              response.data.installationMethods += this.options[v]
            } else {
              response.data.installationMethods += this.options[v] + ','
            }
          })
        }
        this.form = response.data
        console.log(response.data.reportInfoResult.productModelResults, 'response.data.evaluateInfoResult')
        if (response.data.evaluateInfoResult) {
          this.evaluateInfoResult = response.data.evaluateInfoResult
        } else {
          this.evaluateInfoResult = null
        }

        // 试压图片
        if (response.data.reportInfoResult && response.data.reportInfoResult.fileManyFileResults) {
          // this.fileManyFileResults = response.data.reportInfoResult.fileManyFileRes
          // response.data.reportInfoResult.fileManyFileRes.forEach((v) => {
          //   this.optionsType.forEach((item) => {
          //     if (item.type === v.type) {
          //       item.files = v.files
          //     }
          //   })
          // })
          console.log('测试000555')
          this.optionsType = response.data.reportInfoResult.fileManyFileResults
          console.log()
        } else {
        }
        console.log('测试000======================')
        if (response.data.reportInfoResult.spatialData) {
          const arr = response.data.reportInfoResult.spatialData.split(',')
          // response.data.reportInfoResult.spatialDataOne = Number(arr[0])
          // response.data.reportInfoResult.spatialDataTwo = Number(arr[1])
          // response.data.reportInfoResult.spatialDataFree = Number(arr[2])
          // response.data.reportInfoResult.spatialDataFour = Number(arr[3])
          this.spatialDataFour =
            Number(arr[0]) + '室' + Number(arr[1]) + '厅' + Number(arr[2]) + '厨' + Number(arr[3]) + '卫'
        }
        const installationMethods = response.data.reportInfoResult.installationMethod
        if (installationMethods) {
          this.installationMethods =
            installationMethods.indexOf('0') !== -1
              ? '地面走管,'
              : '' + installationMethods.indexOf('1') !== -1
                ? '墙面走管,'
                : '' + installationMethods.indexOf('2') !== -1
                  ? '屋顶走管,'
                  : ''
        }
        if (response.data.reportInfoResult.startTime) {
          const array = response.data.reportInfoResult.pressureDataResults
          // if (array && array.length) {
          //   const leg = array.length - 1
          //   // response.data.reportInfoResult.endTime = array[leg].time
          //   // response.data.reportInfoResult.endTime = array[leg].time
          // } else {
          //   // console.log(response.data.reportInfoResult.startTime, 'startTimestartTimestartTime')
          //   // console.log(response.data.reportInfoResult.presetTime, 'presetTimepresetTimepresetTime')
          //   const presetTime = response.data.reportInfoResult.presetTime
          //   // response.data.reportInfoResult.endTime = moment(response.data.reportInfoResult.startTime)
          //   //   .add(presetTime, 'minutes')
          //   //   .format('YYYY-MM-DD HH:mm:ss')
          // }
        }
        this.reportInfoResult = response.data.reportInfoResult
        // this.productModelResults = response.data.productModelResults
        if (response.data.reportInfoResult) {
          const porModel = response.data.reportInfoResult.productModelResults
          this.form.pointsWater = 0
          this.form.pointsExaminer = 0
          this.form.golden02 = 0
          this.form.golden01 = 0
          porModel.forEach((v) => {
            v.flage = false
            this.form.golden01 += v.golden01
            this.form.golden02 += v.golden02
            this.form.pointsExaminer += v.pointsExaminer
            this.form.pointsWater += v.pointsWater

            // v.inspectorPoints = 0
            // v.dealersIntegral = 0
            // v.hydraulicIntegral = 0
            // console.log(v,'顶顶顶顶======');
          })
          this.productModelResults = porModel
        } else {
          this.productModelResults = []
        }
        const time = []
        const data = []
        if (this.reportInfoResult.pressureDataResults && this.reportInfoResult.pressureDataResults.length) {
          this.reportInfoResult.pressureDataResults.forEach((v) => {
            time.push(v.time)
            data.push(v.data)
          })
          this.chartData = {
            time: time,
            data: data,
          }
        }

        this.open = true

        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj1(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  input {
    width: 30%;
    margin-right: 10px;
  }
}

img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
  cursor: pointer;
}

.card_container {
  margin-top: 10px;
  // background: #f5f5f5;
  // overflow: hidden;
  // padding: 24px;
  display: flex;

  .card_item {
    width: 20%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0 0;
    font-size: 20px;
    cursor: pointer;

    .card_item_c {
      width: 100%;
      text-align: center;
    }

    .card_item_l {
      width: 45%;
      height: 3px;
      background: #4760ff;
      margin: 7px auto 0;
    }
  }

  .active {
    background: #fff;
    height: 60px;
    color: #4760ff;
  }
}

// /dee/.card-container > .ant-tabs-card > .ant-tabs-content {
//   height: 320px;
//   // margin-top: -16px;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
//   background: #fff;
//   padding: 16px;
// }

// .card-container > .ant-tabs-card > .ant-tabs-bar {
//   border-color: #fff;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
//   border-color: transparent;
//   background: transparent;
//   width: 500px;
//   text-align: center;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
//   border-color: #fff;
//   background: #fff;
//   border-radius: 6px 6px 0 0;
//   width: 500px;
//   text-align: center;
//   font-size: 20px;
// }
// /deep/.plan_con {
//   height: 500px !important;
//   width: 500px !important;
// }
.container {
  background: #fff;
  height: 61vh;
  padding: 20px;
  overflow-y: auto;

  /deep/.ant-form-model {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .form_model {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .ant-form-model-item {
      width: 33%;
    }
  }
}

/deep/.ant-form-item {
  width: 32% !important;
  margin-right: 10px;
}

/deep/.ant-card {
  width: 100% !important;
  transition: box-shadow 0.3s ease !important;
  /* 添加过渡效果 */
  margin-bottom: 20px;
}

/deep/.ant-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  /* 鼠标经过时的阴影效果 */
}

.xiang {
  font-size: 15px;
}

.back {
  // background: red;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 100px;
}

.ant-form-item {
  margin-bottom: 5px;
}

.chanTitle {
  width: 80px;
  height: 30px;
  background: #4760ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.chanBian {
  //   height: 30px;
  //  padding:  0 30px;
  //  border: 1px solid #4760ff;
  color: #4760ff;
  //  display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   border-radius: 10px;
  // margin-right:20px;
}
</style>